import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  fullRedirect (event) {
    event.preventDefault()
    const location = event.detail.response.url
    event.detail.visit(location, { action: 'advance' })
  }
}
